import { setAssetGroupsRo } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { useAssetGroupOptions } from './AssetGroupsFilter';

export const AssetGroupsRoFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<string>
      filterName="assetGroupsRo"
      label={label ?? t('AssetGroupRO')}
      action={setAssetGroupsRo}
      elementRef={elementRef}
      useItemsHook={useAssetGroupOptions}
    />
  );
};

export default AssetGroupsRoFilter;
